<template>
    <v-card flat class="outlined-except-top-left">
        <v-container fluid class="content-container" :class="!isMobilePort ? 'px-5' : ''">
            <v-row align="center">
                <v-col cols="12" md="8">
                    <h2 class="text-h4 font-weight-medium">Notes and Bookmarks</h2>
                    <share-feedback />
                </v-col>
                <v-col cols="12" md="4" class="d-flex" :class="{
                    'd-flex justify-end': !isMobilePort
                }">

                  <v-menu offset-y>

                        <template v-slot:activator="{ on, attrs }">
                            <v-btn outlined class="mr-2" v-bind="attrs" v-on="on">
                                Actions
                                <v-icon class="ml-1">mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item :href="getRoute('dashboard_my_tags')">
                                <v-list-item-icon class="mr-3">
                                    <v-icon>mdi-label-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Manage Tags</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                  <v-btn
                      color="primary"
                      @click="onPrintClick"
                      :loading="isPrintLoading"
                  >
                    Print ({{ sectionsCount }} sections)
                  </v-btn>

                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
    import Mobile from '../../inc/mixins/mobile';
    import ShareFeedback from "../../links/ShareFeedback.vue";

    export default {
        components: { ShareFeedback },
        mixins: [Mobile],
        methods: {
          onPrintClick() {
            this.isPrintLoading = true;

            this.$emit('onPrintClick');

            // we do this animation in case of slow connection
            setTimeout(() => {
              this.isPrintLoading = false;
            }, 800);
          }
        },
        data() {
          return {
            isPrintLoading: false
          }
        },
        props: {
            pagination: {
                type: Object,
                required: true
            },
            sectionsCount: {
                type: Number,
                required: true
            }
        }
    }
</script>

<style scoped>
    .outlined-except-top-left {
        border: 1px solid #E0E0E0;
        border-top: none;
        border-left: none;
    }
</style>